import OptimizedImage from "@/components/OptimizedImage";
import * as Dialog from "@radix-ui/react-dialog";
import React, { useState } from "react";
import Marquee from "./Marquee";

const ArtistReview = () => {
  const [clickedStar, setClickedStar] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const onOpenChange = (open: boolean) => setIsOpen(open);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [testimonials, setTestimonials] = useState([
    {
      quote:
        "Arjun delivered more than just star power—his energy was electrifying! He engaged with the crowd, kept the vibe alive, and even stayed for post-event photos. Absolutely surreal experience.",
      author: "Ravi Malhotra ",
      date: "Corporate Event Organizer, Mumbai",
      stars: 5,
      img: "https://plus.unsplash.com/premium_photo-1689539137236-b68e436248de?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90b"
    },
    {
      quote:
        "We booked Arjun for a grand destination wedding appearance, and the impact was unforgettable. He was charming, punctual, and brought Hollywood glamour to our Indian celebration. Worth every penny!",
      author: "Anita Verma",
      date: "Wedding Planner, New Delhi",
      stars: 4,
      img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      quote:
        "Our college couldn’t believe it when Arjun showed up. His presence created a buzz like never before. He interacted warmly, but the security arrangements could’ve been smoother.",
      author: "Karan Sethi",
      date: "College Fest Committee Head, Bangalore",
      stars: 3,
      img: "https://plus.unsplash.com/premium_photo-1689568126014-06fea9d5d341?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      quote:
        "Tom is a total professional. From rehearsals to final walk-ons, he was precise and respectful. Having him headline our award night added an international appeal we’ll never forget.",
      author: "Pooja Joshi",
      date: "Event Producer, Jaipur",
      stars: 4.8,
      img: "https://plus.unsplash.com/premium_photo-1690407617686-d449aa2aad3c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      quote:
        "We got Arjun for our product launch and he owned the stage. Charisma, discipline, and Hollywood glam—he aligned perfectly with our premium brand image.",
      author: "Devansh Kapadia",
      date: "Brand Activation Manager, Gurgaon",
      stars: 2,
      img: "https://images.unsplash.com/photo-1654110455429-cf322b40a906?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      quote:
        "Arjun was stunning on stage and off. Only minor hiccup was tight time constraints, but what he delivered in those 20 minutes was pure magic!",
      author: "Nisha Rao",
      date: "Public Relations Consultant, Hyderabad",
      stars: 4.7,
      img: "https://images.unsplash.com/photo-1688888745596-da40843a8d45?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      quote:
        "This was a fan’s dream come true. Tom was gracious, spoke a few words in Hindi, and left the crowd in awe. A memory for a lifetime.",
      author: "Arvind Chatterjee",
      date: "Fan Meet Organizer, Kolkata",
      stars: 4.9,
      img: "https://plus.unsplash.com/premium_photo-1671656349322-41de944d259b?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      quote:
        "He brought cinematic flair to our experiential event. We only wish we had more time for audience interaction. But the thrill he generated? Next-level.",
      author: "Sahil Mehta",
      date: "Experiential Marketing Executive, Pune",
      stars: 4.1,
      img: "https://plus.unsplash.com/premium_photo-1689629870780-5d0e655383e6?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      quote:
        "Fantastic service! The artist we booked was truly talented and made our event special.",
      author: "Deepak Agarwal",
      date: "September 30, 2024",
      stars: 5,
      img: "https://images.unsplash.com/photo-1695927621677-ec96e048dce2?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      quote:
        "Arjun redefined celebrity appearances for us. From red carpet charm to off-stage warmth, he made our high-profile event feel intimate and exclusive.",
      author: "Tanya Bansal",
      date: "Luxury Event Planner, Udaipur",
      stars: 3.5,
      img: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?q=80&w=1727&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
  ]);

  const handleSubmitReview = () => {
    if (clickedStar > 0 && reviewText.trim()) {
      setIsLoading(true);
      setSuccessMessage("");

      setTimeout(() => {
        const newReview = {
          quote: reviewText,
          author: "New User",
          date: new Date().toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
          stars: clickedStar,
        };

        setTestimonials((prev) => [...prev, newReview]);
        setReviewText("");
        setIsLoading(false);
        setSuccessMessage("Review submitted successfully!");
        setClickedStar(0);
        setTimeout(() => {
          onOpenChange();
        }, 2000);
      }, 3000);
    }
  };

  const renderStars = (stars) => {
    const fullStars = Math.floor(stars);
    const halfStar = stars % 1 !== 0;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
      <div className="flex space-x-1">

        {[...Array(fullStars)].map((_, i) => (
          <svg
            key={`full-${i}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="gold"
            className="size-4 md:size-4"
          >
            <path
              fillRule="evenodd"
              d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
              clipRule="evenodd"
            />
          </svg>
        ))}
        {halfStar && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="gold"
            className="size-4 md:size-4"
          >
            <defs>
              <linearGradient id="halfStar">
                <stop offset="50%" stopColor="gold" />
                <stop offset="50%" stopColor="gray" />
              </linearGradient>
            </defs>
            <path
              fill="url(#halfStar)"
              d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
            />
          </svg>
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <svg
            key={`empty-${i}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="gray"
            className="size-4 md:size-4"
          >
            <path
              fillRule="evenodd"
              d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
              clipRule="evenodd"
            />
          </svg>
        ))}
      </div>
    );
  };

  return (
    <div className="mt-10 w-screen">
      <section className="overflow-hidden p-4">
        <div className="flex flex-col-reverse">
          <div className="flex justify-between flex-row gap-4 mt-10 lg:px-20">
            <div>
              <h4 className="text-3xl max-md:text-2xl font-bold">
                Rate this Artist
              </h4>
              <p className="text-xl max-sm:text-base font-light">
                Tell others what you think about this artist
              </p>
            </div>

            <div className="flex items-end flex-col justify-end">
              <div className="flex items-center space-x-2">
                {[1, 2, 3, 4, 5].map((item) => {
                  return (
                    <svg
                      key={item}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill={clickedStar >= item ? "gold" : "gray"}
                      className="size-8 cursor-pointer transition-all duration-500 "

                    >
                      <path
                        fillRule="evenodd"
                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  );
                })}
              </div>
              <button
                // onClick={() => {
                //   setClickedStar(5);
                //   onOpen();
                // }}
                className="text-xl  border-zinc-500 transition-all duration-300 px-2 max-sm:text-base font-light mt-4 underline underline-offset-4 bg-gradient-to-r from-orange-600 to-pink-700 bg-clip-text text-transparent hover:border-b"
              >
                Write a review{" "}
              </button>
            </div>
          </div>

          <div className="relative">
            {/* Gradient overlays */}
            {/* Scrolling container */}
            <h3 className="text-[28px] text-center md:text-[42px] font-bold bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text mb-5">REVIEWS</h3>
            <Marquee
              direction="left"
              speed={50}
              pauseOnHover
              className="h-auto overflow-hidden "
            >
              <div className="flex gap-6 py-4">
                {/* Double the testimonials for seamless loop */}
                {testimonials.map(
                  (
                    testimonial: {
                      quote: string;
                      author: string;
                      date: string;
                      stars: number;
                      img: string;
                    },
                    index
                  ) => (
                    <blockquote
                      key={index}
                      className="rounded-3xl cursor-grab bg-gray-100 p-4 w-96 md:min-w-96 md:max-w-96 overflow-hidden whitespace-normal shrink-0"
                    >
                      <div className="flex items-center justify-between w-full min-w-0">
                        <div className="flex items-center gap-4 ">
                          <OptimizedImage
                            src={testimonial.img}
                            className="size-10 md:size-14 rounded-full object-cover"
                            alt=" testimonial author image "
                            unoptimized={true}
                            height={56}
                            width={56}
                          />

                          <p className="mt-0.5 text-sm md:text-lg font-medium text-gray-900">
                            {testimonial.author}
                          </p>
                        </div>

                        <div className="flex items-center space-x-2 text-amber-600">
                          <div className="mt-2">
                            {renderStars(testimonial.stars)}
                          </div>
                        </div>
                      </div>
                      <p className="mt-2 md:mt-4 text-gray-700 text-xs md:text-base break-words whitespace-normal">{testimonial.quote}</p>
                      <p className="mt-2 md:mt-4 text-black text-xs font-semibold">
                        {testimonial.date}
                      </p>
                    </blockquote>
                  )
                )}
              </div>
            </Marquee>
          </div>
        </div>
      </section>
      <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
          <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md bg-black text-white border border-zinc-700 rounded-lg p-6 shadow-xl">
            <Dialog.Title className="text-lg font-semibold mb-4">
              Write a Review
            </Dialog.Title>
            <div>
              {isLoading ? (
                <div className="flex flex-col items-center">
                  <svg
                    className="animate-spin h-8 w-8 text-white"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="white"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                  <p className="mt-2">Submitting...</p>
                </div>
              ) : successMessage ? (
                <div className="text-green-400 py-10 flex justify-center items-center flex-col">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-16"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                    />
                  </svg>

                  <p>{successMessage}</p>
                </div>
              ) : (
                <>
                  <div className="flex justify-center gap-1 mb-4">
                    {[1, 2, 3, 4, 5].map((item, i) => (
                      <svg
                        key={i}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill={clickedStar >= item ? "gold" : "gray"}
                        className="size-8 cursor-pointer transition-all duration-500 "
                        onClick={() => setClickedStar(item)}
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ))}
                  </div>
                  <div>
                    <label htmlFor="name" className="text-sm w-full">
                      <p>Full Name</p>
                      <input
                        placeholder="Enter full name"
                        className="w-full bg-black p-4 border border-zinc-600"
                      />
                    </label>
                  </div>
                  <div>
                    <label htmlFor="review" className="text-sm w-full">
                      <p>We’d love to hear more from you (optional).</p>
                      <textarea
                        value={reviewText}
                        onChange={(e) => setReviewText(e.target.value)}
                        placeholder="Enter your message"
                        className="w-full bg-black p-4 border border-zinc-600"
                      />
                    </label>
                  </div>
                </>
              )}
            </div>
            {!(successMessage || isLoading) && (
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  onClick={() => {
                    setClickedStar(0);
                    setIsOpen(false);
                  }}
                  className="px-4 py-2 rounded text-white border border-zinc-600"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmitReview}
                  disabled={!reviewText.trim()}
                  className="bg-pink-700 px-4 py-2 rounded text-white"
                >
                  Submit Review
                </button>
              </div>
            )}
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  );
};

export default ArtistReview;
